import {arrowDecreaseSvg as Icon__small__arrowDecreaseSvg} from '../Icon__small/Icon__small--arrowDecrease.js';

export var arrowDecrease = {
  name: 'arrowDecrease',
  category: 'icon',
  colorable: true,
  svg: Icon__small__arrowDecreaseSvg,
};
